import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const SortIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M1.16666 5.01552L4.49999 1.66675L7.83332 5.01552" stroke="#084C83" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg {...props} width="100%" height="100%" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};